import { GridColumnHeaderParams } from "@mui/x-data-grid-pro";

import { AllWasteTypesFilter } from "../../../../components/TableFilters/AllWasteTypesFilter";
import { BooleanFilter } from "../../../../components/TableFilters/BooleanFilter";
import { DateFilter } from "../../../../components/TableFilters/DateFilter";
import { NumberFilter } from "../../../../components/TableFilters/NumberFilter";
import { TextFilter } from "../../../../components/TableFilters/TextFilter";
import { TableHeaderCell } from "../../../../components/TableHeaderCell";
import {
  removeCollectionYardsFilter,
  setCollectionYardsFilter,
  setCollectionYardsListOrdering,
} from "../../../../reducers/collectionYardsReducer";
import {
  getCollectionYardsFilterIsActiveCached,
  getCollectionYardsFilterValueCached,
  getCollectionYardsOrderingValue,
} from "../../../../selectors/collectionYards";
import { ColumnType } from "../CollectionYardsTableColumnTypes";

const TABLE_NAME = "collectionYardsVisits";

interface IHeaderCellProps {
  params: GridColumnHeaderParams;
}

const selectFilters = (type: string) => {
  switch (type) {
    case ColumnType.created:
      return (
        <DateFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsFilterValueCached}
          filterUpdateAction={setCollectionYardsFilter}
        />
      );
    case ColumnType.locationName:
    case ColumnType.collectionYardName:
      return (
        <TextFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsFilterValueCached}
          filterUpdateAction={setCollectionYardsFilter}
        />
      );
    case ColumnType.wcpid:
    case ColumnType.wasteSum:
    case ColumnType.priceSum:
      return (
        <NumberFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsFilterValueCached}
          filterUpdateAction={setCollectionYardsFilter}
        />
      );
    case ColumnType.wasteTypes:
      return (
        <AllWasteTypesFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsFilterValueCached}
          filterUpdateAction={setCollectionYardsFilter}
        />
      );
    case ColumnType.paid:
      return (
        <BooleanFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsFilterValueCached}
          filterUpdateAction={setCollectionYardsFilter}
        />
      );
    default:
      return <div />;
  }
};

export const CollectionYardsTableHeaderCell: React.FC<IHeaderCellProps> = ({ params }) => {
  return (
    <TableHeaderCell
      tableName={TABLE_NAME}
      params={params}
      selectorOrdering={getCollectionYardsOrderingValue}
      selectorFilterIsActive={getCollectionYardsFilterIsActiveCached}
      removeFilterUpdateAction={removeCollectionYardsFilter}
      selectFilters={selectFilters}
      orderingUpdateAction={setCollectionYardsListOrdering}
    />
  );
};
